import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { getProblemInfo, getProblemsForStage } from '../../../dict/PROBLEMS'
import { Li } from '.'
import RootStoreContext from '../../../storage/RootStore'

/// functions
/// types
/// components

interface ProblemsProps {
    forStage: string
}

export const Problems: React.FC<ProblemsProps> = observer(({
    forStage: stageID
}) => {

    
    const {selection} = useContext(RootStoreContext)

return (
    <>
    <p>Проблеми пов'язані з цим етапом:</p>
    <ul>
        {getProblemsForStage(stageID).map(problemID => {
            const { problemName } = getProblemInfo(problemID)

            const id = `problem-${problemID}-connected`

            const onClick = () => {
                selection.setView('problems')
                selection.setProblem(problemID)
            }

            return (
                <Li key={id} id={id} onClick={onClick}>
                    {problemName}
                </Li>
            )
        })}
    </ul>
    </>
)
})
